export const companyFeatureQueryKeys = {
  base: ['companyFeature'] as const,
  companyFeatures: (companyId: number) => [...companyFeatureQueryKeys.base, 'list', companyId] as const,
};
